/**
 * Acervo e Metadados dos Manuais Oficiais da Honda ADV 150 (K0W)
 * Padrão Fábio Akita - Boring Technology & Contratos Estritos
 */

export interface ManualResource {
  id: string;
  title: string;
  category: "proprietario_global" | "proprietario_brasil" | "pecas_epc" | "servico_oficina";
  modelCode: string;
  source: string;
  publicationCode?: string;
  language: "pt-BR" | "en";
  pageCount?: number;
  url: string;
  localPath?: string;
  description: string;
}

export const ADV150_MANUAL_RESOURCES: ManualResource[] = [
  {
    id: "man-proprietario-global-k0w",
    title: "Honda ADV 150 Owner's Manual (Original de Fábrica)",
    category: "proprietario_global",
    modelCode: "ADV150 / ADV150A (K0W)",
    source: "Honda MotoPub Global CDN (Amazon S3 / CloudFront)",
    publicationCode: "32K0WA020",
    language: "en",
    pageCount: 155,
    url: "https://2rom-prd-data.hondamotopub.com/om/HPI/ADV150/2020/ADV150_32K0WA020_0.pdf",
    localPath: "docs/manuais/ADV150_Manual_Original_Honda_32K0WA020.pdf",
    description:
      "Manual original de fábrica com especificações completas de operação, segurança, chave presencial e manutenção.",
  },
  {
    id: "man-proprietario-brasil",
    title: "Manual do Proprietário Honda ADV 150 (Brasil)",
    category: "proprietario_brasil",
    modelCode: "ADV 150 (K0W Brasil)",
    source: "Moto Honda da Amazônia Ltda. / Honda Pós-Venda",
    language: "pt-BR",
    pageCount: 261,
    url: "https://www.honda.com.br/pos-venda/motos/manuais-e-guias",
    description:
      "Manual nacional oficial em português homologado no Brasil, disponível no portal de pós-venda e app myHonda Connect.",
  },
  {
    id: "man-catalogo-pecas-epc",
    title: "Honda ADV 150 Parts Catalogue (Catálogo Eletrônico de Peças EPC)",
    category: "pecas_epc",
    modelCode: "ADV150AL (K0W)",
    source: "Honda Motor Co., Ltd. / MotoPub",
    publicationCode: "18K0WLI1",
    language: "en",
    url: "https://www.hondamotopub.com/pc/HPI/ADV150/2020",
    description:
      "Vistas explodidas detalhadas e códigos de peças originais OEM de todos os subconjuntos mecânicos e elétricos.",
  },
  {
    id: "man-servico-oficina",
    title: "Honda ADV 150 Scooter Service Manual (Manual de Serviço Concessionária)",
    category: "servico_oficina",
    modelCode: "ADV150A (K0W)",
    source: "Honda Dream Workshop Standards",
    language: "en",
    pageCount: 211,
    url: "https://www.hondamotopub.com/model/HPI/K0W201",
    description:
      "Manual mestre de oficina técnica com tolerâncias centesimais, torques de aperto em N.m e diagramas elétricos unifilares.",
  },
];
